import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import heroBg from "../assets/images/hero-bg.jpg";

const HeroContainer = styled.div`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.4)), url('${heroBg}');
  height: 100vh;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.2);
  object-fit: contain;

  @media screen and (max-width: 600px) {
    height: 90vh;
  }
`;

const HeroContent = styled.div`
  max-width: 1200px;
  width: 90%;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeroH1 = styled(motion.h1)`
  color: #fff;
  font-size: 48px;
  text-align: center;
  font-family: 'Playfair Display', serif;
  margin-bottom: 24px;
  
  @media screen and (max-width: 768px) {
    font-size: 40px;
  }

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

const HeroP = styled(motion.p)`
  margin-top: 24px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  max-width: 800px;
  font-family: 'Open Sans', sans-serif;
  
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

const HeroButtonWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const HeroButton = styled(motion.button)`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#4CAF50' : 'transparent')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 30px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: ${({ primary }) => (primary ? 'none' : '1px solid #fff')};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  margin: 0 10px;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#fff' : '#4CAF50')};
    color: ${({ primary }) => (primary ? '#4CAF50' : '#fff')};
    border: ${({ primary }) => (primary ? '1px solid #4CAF50' : 'none')};
  }
  
  @media screen and (max-width: 768px) {
    margin: 10px 0;
    width: 100%;
  }
`;

const Hero = () => {
  return (
    <HeroContainer>
      <HeroContent>
        <HeroH1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Infraestrutura moderna e de excelência!
        </HeroH1>
        <HeroP
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          O Memorial Dom José é um local planejado para oferecer conforto e dignidade no momento de despedida. 
        </HeroP>
        {/*<HeroButtonWrapper>
          <HeroButton 
            primary={true}
            big={true}
            fontBig={true}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            Nossos Serviços
          </HeroButton>
          <HeroButton 
            primary={false}
            big={true}
            fontBig={true}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
          >
            Entre em Contato
          </HeroButton>
        </HeroButtonWrapper>*/}
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
